import Repeater_SlideshowComponent from '../components/Repeater/viewer/skinComps/Slideshow/Slideshow.skin';
import Repeater_SlideshowController from '../components/Repeater/viewer/Repeater.controller';
import SlideshowComponent from '../components/Slideshow/Slideshow/viewer/Slideshow';
import SlideshowController from '../components/Slideshow/Slideshow/viewer/Slideshow.controller';
import SlideshowButton_DefaultComponent from '../components/Slideshow/SlideshowButton/viewer/skinComps/Default/Default.skin';
import SlideshowButton_DefaultController from '../components/Slideshow/SlideshowButton/viewer/SlideshowButton.controller';
import SlideshowButton_SlideshowButtonComponent from '../components/Slideshow/SlideshowButton/viewer/skinComps/SlideshowButton/SlideshowButton.skin';
import SlideshowButtonComponent from '../components/Slideshow/SlideshowButton/viewer/SlideshowButton';
import SlideshowIndicatorComponent from '../components/SlideshowIndicator/viewer/SlideshowIndicator';
import SlideshowIndicatorController from '../.components/SlideshowIndicator/viewer/SlideshowIndicator.controller';


const Repeater_Slideshow = {
  component: Repeater_SlideshowComponent,
  controller: Repeater_SlideshowController
};

const Slideshow = {
  component: SlideshowComponent,
  controller: SlideshowController
};

const SlideshowButton_Default = {
  component: SlideshowButton_DefaultComponent,
  controller: SlideshowButton_DefaultController
};

const SlideshowButton_SlideshowButton = {
  component: SlideshowButton_SlideshowButtonComponent,
  controller: SlideshowButton_DefaultController
};

const SlideshowButton = {
  component: SlideshowButtonComponent,
  controller: SlideshowButton_DefaultController
};

const SlideshowIndicator = {
  component: SlideshowIndicatorComponent,
  controller: SlideshowIndicatorController
};


export const components = {
  ['Repeater_Slideshow']: Repeater_Slideshow,
  ['Slideshow']: Slideshow,
  ['SlideshowButton_Default']: SlideshowButton_Default,
  ['SlideshowButton_SlideshowButton']: SlideshowButton_SlideshowButton,
  ['SlideshowButton']: SlideshowButton,
  ['SlideshowIndicator']: SlideshowIndicator
};

